const DEFAULT_DELAY_MS = 50;
const RANDOM_DELAY_MIN_MS = 100;
const RANDOM_DELAY_RANGE_MS = 500;

const wait = (ms = DEFAULT_DELAY_MS): Promise<void> =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

const waitRandom = (): Promise<void> => {
  const randomMs = Math.floor(Math.random() * RANDOM_DELAY_RANGE_MS) + RANDOM_DELAY_MIN_MS;

  const promise = wait(randomMs);

  return promise;
};

export { wait, waitRandom };
